import { createContext, useEffect, useState } from 'react';
import { Table, TablesResponse, TableResponse, CountriesResponse, Country, SectionResponse, SectionsResponse, Section } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type TablesContextProps = {
    tables: Table[];
    sections: Section[];
    totalPage: number;
    loadTables: (page: number) => Promise<void>;
    addTable: (table: Table) => Promise<string>;
    updateTable: (table: Table) => Promise<string>;
    deleteTable: (id: number) => Promise<string>;
    getTableToken: (id: number) => Promise<string>;
    // Plano de mesas: guarda TODA una sección (PUT /table/layout)
    saveLayout: (payload: { sectionId: number | null; tables: any[] }) => Promise<{ tables?: Table[]; error?: string; details?: { tableId: number | null; field: string; message: string }[]; status?: number }>;
    //loadSections: () => Promise<Section[]>;

}



export const TablesContext = createContext({} as TablesContextProps);

export const TablesProvider = ({ children }: any) => {

    const [tables, setTables] = useState<Table[]>([]);
    const [sections, setSections] = useState<Section[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    useEffect(() => {
        loadTables(0);
        loadSections();
    }, [])

    const loadSections = async () => {

        /*const resp = await topApi.get<SectionsResponse>('/section/getSections');
        if (resp.status == 200) {
            return resp.data.sections;
        } else {
            return [];
        }*/
        const resp = await topApi.get<SectionsResponse>('/section/getSections');
        if (resp.status == 200) {
            setSections([...resp.data.sections]);
            setTotalPage(1);
        }
    }


    const loadTables = async (pageActual) => {

        const resp = await topApi.get<TablesResponse>('/table/getTables');
        if (resp.status == 200) {
            setTables([...resp.data.tables]);
            setTotalPage(1);
        }


    }

    const saveLayout = async (payload: { sectionId: number | null; tables: any[] }) => {
        try {
            const resp = await topApi.put<TablesResponse>('/table/layout', payload);
            const updated = resp.data.tables ?? [];
            // Reemplaza en el listado las mesas de la sección con lo que devolvió el servidor
            setTables(prev => prev.map(t => updated.find(u => u.id === t.id) ?? t));
            return { tables: updated };
        } catch (e) {
            return {
                error: e.response?.data?.error || "Ocurrió un error de comunicación, intente de nuevo.",
                details: e.response?.data?.details,
                status: e.response?.status,
            };
        }
    }

    const addTable = async (table: Table) => {
        try {
            table.id = undefined;
            const resp = await topApi.post<TableResponse>('/table/', { table });
            setTables([...tables, resp.data.table]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateTable = async (table: Table) => {
        try {
            const resp = await topApi.put<Table>(`/table/${table.id}`, { table });

            setTables(tables.map(prod => {
                return (prod.id === table.id)
                    ? resp.data["table"]
                    : prod;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteTable = async (id: number) => {
        try {
            await topApi.delete<Table>(`/table/${id}`);
            setTables((prevTables) =>
                prevTables.filter((table) => table.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const getTableToken = async (id: number) => {
        try {
            const resp = await topApi.get(`/table/getTableToken/${id}`);

            return resp.data["tokenTable"];
        } catch (e) {
            return "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }



    return (
        <TablesContext.Provider value={{ tables, totalPage, loadTables, addTable, updateTable, deleteTable, sections, getTableToken, saveLayout }}>
            {children}
        </TablesContext.Provider>
    );
}